export default "__VITE_ASSET__CZPL4U1s__"